import React from 'react';

const FAQ: React.FC = () => {
  const faqItems = [
    {
      question: "Comment ajouter un nouveau chauffeur ?",
      answer: "Pour ajouter un nouveau chauffeur, allez dans la section 'Gestion des chauffeurs' et cliquez sur le bouton 'Nouveau' en haut à droite. Remplissez ensuite le formulaire avec les informations du chauffeur et cliquez sur 'Enregistrer'."
    },
    {
      question: "Comment modifier les informations d'un chauffeur ?",
      answer: "Dans la section 'Gestion des chauffeurs', trouvez le chauffeur que vous souhaitez modifier dans la liste. Cliquez sur l'icône de modification (crayon) à côté de son nom. Mettez à jour les informations dans le formulaire qui s'affiche et cliquez sur 'Enregistrer'."
    },
    {
      question: "Comment supprimer un chauffeur ?",
      answer: "Pour supprimer un chauffeur, allez dans la section 'Gestion des chauffeurs', trouvez le chauffeur dans la liste et cliquez sur l'icône de suppression (poubelle) à côté de son nom. Confirmez la suppression dans la boîte de dialogue qui apparaît."
    },
    {
      question: "Comment accéder aux paramètres de l'application ?",
      answer: "Les paramètres de l'application sont accessibles en cliquant sur l'icône 'Paramètres' dans la barre latérale. Vous y trouverez diverses options pour personnaliser l'application selon vos besoins."
    },
    {
      question: "Comment puis-je me déconnecter de l'application ?",
      answer: "Pour vous déconnecter, cliquez sur le bouton 'Déconnexion' situé en bas de la barre latérale. Cela vous ramènera à la page de connexion."
    }
  ];

  return (
    <div className="flex flex-col h-[calc(100vh-70px)] bg-slate-50">
      <div className='px-12 flex flex-col h-full'>
        <div className="">
          <h1 className="text-3xl font-bold">Foire Aux Questions</h1>
        </div>
        <div className="flex-1 overflow-hidden">
          <div className="h-full overflow-y-auto pr-4 -mr-4">
            <div className="space-y-6 pb-6">
              {faqItems.map((item, index) => (
                <div key={index} className="bg-white shadow-md rounded-lg p-6">
                  <h2 className="text-xl font-semibold mb-3">{item.question}</h2>
                  <p className="text-gray-700">{item.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;